export default class Participant{

  constructor(){
    this.inscripcion = null;
    this.documento = null;
    this.documento_tipo = null;
    this.nombres = null;
    this.apellidos = null;
    this.correo_principal = null;
    this.correo_secundario = null;
    this.contacto_principal = null;
    this.contacto_secundario = null;
    this.pais = null;
    this.departamento = null;
    this.ciudad = null;
    this.tipo_institucion = null;
    this.id_institucion = null;
    this.nombre_institucion = null;
    this.ubicacion_institucion = null;
    this.cargo = null;
    this.trayectoria = null;
    this.formacion = null;
    this.edad = null;
    this.genero = null;
    this.migrantes = 0;
    this.jornada = null;
    this.estado_cuenta = null;
  }

  setdata(data){
    this.inscripcion = data.idnscripcion;
    this.documento = data.documento_numero;
    this.documento_tipo = data.documento_tipo;
    this.nombres = data.nombres;
    this.apellidos = data.apellidos;
    this.correo_principal = data.correo_principal;
    this.correo_secundario = data.correo_secundario;
    this.contacto_principal = data.contacto_principal;
    this.contacto_secundario = data.contacto_secundario;
    this.pais = data.ubicacion_pais;
    this.departamento = data.iddepartamento;
    this.ciudad = data.ubicacion_ciudad;
    this.tipo_institucion = data.institucion_tipo;
    this.id_institucion = data.idinstitucion;
    this.nombre_institucion = data.institucion;
    this.ubicacion_institucion = data.institucion_ubicacion;
    this.cargo = data.idcargo;
    this.trayectoria = data.idtrayectoria;
    this.formacion = data.idformacion;
    this.edad = data.idedad;
    this.genero = data.genero;
  }

  reset(){
    this.inscripcion = null;
    this.documento = null;
    this.nombres = null;
    this.apellidos = null;
    this.correo_principal = null;
    this.correo_secundario = null;
    this.contacto_principal = null;
    this.contacto_secundario = null;
    this.pais = null;
    this.departamento = null;
    this.ciudad = null;
    this.tipo_institucion = null;
    this.id_institucion = null;
    this.nombre_institucion = null;
    this.ubicacion_institucion = null;
    this.cargo = null;
    this.trayectoria = null;
    this.formacion = null;
    this.edad = null;
    this.genero = null;
    this.migrantes = 0;
    this.estado_cuenta = null;
  }

}